import React from 'react';

const DebuggingGridRect = ({pageBox, printingOffsets, style }) => {
  const { l, t, r, b } = pageBox;
  const { l: offL, t: offT, r: offR, b: offB } = printingOffsets;
  const print_area = {
    x: l + offL,
    y: t + offT,
    width: r + offR - offL,
    height: b + offB - offT
  };
  const area = {
    x: l <= print_area.x? l : print_area.x,
    y: t <= print_area.y? l : print_area.y,
    width: r >= print_area.x - l + print_area.width? r : print_area.x - l + print_area.width,
    height: b >= print_area.y - t + print_area.height? b : print_area.y - t + print_area.height,
  };
  const rows = Math.ceil(area.height);
  const cols = Math.ceil(area.width);
  const lines = [];
  for (let r = 0; r <= rows; r++) {
    const isTen = r%10 === 0;
    const isFive = r%5 === 0;
    lines.push(
      <line
        key={'debugging_grid_row_'+r}
        x1={area.x}
        y1={area.y + r}
        x2={area.x + area.width}
        y2={area.y + r}
        stroke={isTen? "#E80202FF" : isFive? "#E80202CC" : "#E8020288"}
        strokeWidth={isTen? 0.025 : isFive? 0.0175 : 0.01}
      />
    )
  }
  for (let c = 0; c <= cols; c++) {
    const isTen = c%10 === 0;
    const isFive = c%5 === 0;
    lines.push(
      <line
        key={'debugging_grid_col_'+c}
        x1={area.x + c}
        y1={area.y}
        x2={area.x + c}
        y2={area.y + area.height}
        stroke={isTen? "#E80202FF" : isFive? "#E80202CC" : "#E8020288"}
        strokeWidth={isTen? 0.025 : isFive? 0.0175 : 0.01}
      />
    )
  }
  return lines
};

export default React.memo(DebuggingGridRect);